import { PDFDocument, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'

export async function createPDFDocument() {
  // PDF Creation
  const pdfDoc = await PDFDocument.create()

  //埋込フォント使用
  pdfDoc.registerFontkit(fontkit);

  return pdfDoc
}

// 文字出力関数(drawTextのラッパ)
export const customDrawText = (page, text, option) => {
  var x = option.x
  const size = option.size
  
  const charArray = text.split('')

  Array.from(charArray).forEach((charStr) => {
    page.drawText(charStr, {...option, x : x})
    x += option.font.widthOfTextAtSize(charStr, size)
  })
}

export const getFontArrayBuffer = async (f) => {
  return await (await fetch(f)).arrayBuffer();
}